import { io, type ManagerOptions, type Socket, type SocketOptions } from 'socket.io-client';
import { getApiOrigin, normalizeApiOrigin } from '@/lib/api';

/** Origem usada pelo Socket.IO (dev: proxy Vite; produção: host da API sem path). */
export function getSocketOrigin(): string {
  const viteEnv = (import.meta as any).env as {
    DEV?: boolean;
    VITE_SOCKET_URL?: string;
    VITE_API_URL?: string;
  } | undefined;

  if (viteEnv?.DEV && typeof window !== 'undefined') {
    return window.location.origin;
  }

  if (viteEnv?.VITE_SOCKET_URL) {
    return normalizeApiOrigin(viteEnv.VITE_SOCKET_URL);
  }

  return getApiOrigin();
}

const DEFAULT_SOCKET_OPTIONS: Partial<ManagerOptions & SocketOptions> = {
  transports: ['polling', 'websocket'],
  withCredentials: true,
  timeout: 20000,
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
};

export function createAppSocket(
  options?: Partial<ManagerOptions & SocketOptions>
): Socket {
  return io(getSocketOrigin(), {
    ...DEFAULT_SOCKET_OPTIONS,
    ...options,
  });
}
